// @flow

import React from "react";
import { Button, ButtonGroup } from "../button";
import type { ButtonColor } from "../button";

export type ToggleButtonItem = $Exact<{
  label: string,
  value: string | number | boolean,
  active: boolean | null,
  activeColor?: ButtonColor,
  buttonClassName?: string,
}>;

export type Props = $Exact<{
  initialValue: ?string | boolean,
  items: ToggleButtonItem[],
  onChange: (value: string | null) => void,
  disabled?: boolean,
  readonly?: boolean,
  className?: string,
}>;

type State = $Exact<{
  selectedValue: any,
}>;

export class ToggleButton extends React.Component<Props, State> {
  static defaultProps = {
    initialValue: null,
  };

  state = {
    selectedValue: null,
  };

  componentDidUpdate(prevProps: Props) {
    if (this.props.initialValue !== prevProps.initialValue) {
      this.setState({ selectedValue: this.props.initialValue });
    }
  }

  parseValue(value: any): any {
    if (value === "true" || value === "false") {
      return value === "true";
    }

    return value || null;
  }

  handleClick = (event: SyntheticEvent<HTMLButtonElement>) => {
    const value = this.parseValue(event.currentTarget.getAttribute("data-value"));
    this.setState(
      {
        selectedValue: value,
      },
      () => this.props.onChange(value),
    );
  };

  isActive = (item: $Exact<{ isActive: ?boolean, value?: string | number | boolean }>) => {
    const { selectedValue } = this.state;
    const { initialValue } = this.props;

    if (item.isActive) {
      return item.isActive;
    }
    if (item.value === selectedValue) {
      return item.value === selectedValue;
    }
    if (item.value === initialValue && item.isActive === null) {
      return item.value === initialValue;
    }
    return false;
  };

  render() {
    return (
      <div className={this.props.className}>
        <ButtonGroup disabled={this.props.disabled} readonly={this.props.readonly}>
          {this.props.items.map(
            ({ label, value, activeColor, buttonClassName, active: isActive }) => {
              const selected = this.isActive({ isActive, value });

              return (
                <Button
                  key={value.toString()}
                  color={selected ? activeColor || "selected" : null}
                  data-value={value}
                  onClick={!this.props.disabled ? this.handleClick : () => {}}
                  fillSpace
                  type="button"
                  className={buttonClassName}
                >
                  {label}
                </Button>
              );
            },
          )}
        </ButtonGroup>
      </div>
    );
  }
}

ToggleButton.displayName = "ToggleButton";

export default ToggleButton;
